import { spacing } from './variables';
// ProductCard listing pages always use a fixed 12px; ProductDetailImages V1/V2 scale up at sm-md and lg/xl
export const getBadgeTextFontSize = (params, breakpoint) => {
    if (params.isFromProductCard)
        return '12px';
    const isProductDetail = params.isFromProductDetail || params.isFromProductDetailV2;
    if (!isProductDetail)
        return undefined;
    const fontSizeByBreakpoint = {
        base: '12px',
        sm: '16px',
        md: '12px',
        lg: '16px',
        xl: '20px',
    };
    return fontSizeByBreakpoint[breakpoint];
};
// ProductCard uses a fixed letterSpacing/lineHeight; ProductDetailImages V1/V2 vary by breakpoint
export const getBadgeTextSpacingOverride = (params, breakpoint) => {
    if (params.isFromProductCard) {
        return { letterSpacing: '0.2px', lineHeight: spacing.medium };
    }
    if (params.isFromProductDetail || params.isFromProductDetailV2) {
        const letterSpacingByBreakpoint = {
            base: '0.2px',
            sm: '0.8px',
            md: '0.2px',
            lg: '0.8px',
            xl: '0.8px',
        };
        return {
            letterSpacing: letterSpacingByBreakpoint[breakpoint],
            lineHeight: breakpoint === 'xl' ? '28px' : spacing.medium,
        };
    }
    return {};
};
